import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Dialog } from '@root/shared/ui-kit'

import { openCreateCurrencyModalEvent } from '../atoms/reatom-currency-create-form'

import { CurrencyCreateForm } from './currency-create-form'

type CreateCurrencyModalProps = {}

export const CreateCurrencyModal = (_props: CreateCurrencyModalProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  useEffect(() => openCreateCurrencyModalEvent.onCall(() => setOpen(true)), [])

  return (
    <Dialog
      variant="bordered"
      open={open}
      onOpenChange={setOpen}
      describedBy={t('currency.create-token')}
    >
      <Dialog.Header title={t('currency.create-token')} />
      <Content>
        <Wrapper>
          <CurrencyCreateForm onDone={() => setOpen(false)} />
        </Wrapper>
      </Content>
    </Dialog>
  )
}

const Content = styled.div`
  width: 360px;
`

const Wrapper = styled.div`
  background: #1b1b1b;
  padding: 10px;
  border-radius: 12px;
`
